import React, { useState } from 'react';
import { backgroundTaskService } from '../services/backgroundTaskService.js';

const BackgroundProcessingTest = () => {
  const [testResult, setTestResult] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const testWebsiteAnalysis = async () => {
    setIsLoading(true);
    setTestResult('Starting website analysis test...');
    
    try {
      // Create a test website analysis task
      const task = await backgroundTaskService.createTask('website_analysis', {
        websites: ['https://example.com'],
        options: { test: true }
      });
      
      setTestResult(`✅ Successfully created background task: ${task.id}\nStatus: ${task.status}\nType: ${task.type}`);
    } catch (error) {
      setTestResult(`❌ Error: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const testEmailVerification = async () => {
    setIsLoading(true);
    setTestResult('Starting email verification test...');
    
    try {
      // Create a test email verification task
      const task = await backgroundTaskService.createTask('email_verification', {
        emails: ['test@example.com'],
        options: { test: true }
      });
      
      setTestResult(`✅ Successfully created background task: ${task.id}\nStatus: ${task.status}\nType: ${task.type}`);
    } catch (error) {
      setTestResult(`❌ Error: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const testTaskRetrieval = async () => {
    setIsLoading(true);
    setTestResult('Testing task retrieval...');
    
    try {
      const tasks = await backgroundTaskService.getUserTasks();
      setTestResult(`✅ Successfully retrieved ${tasks.length} tasks\n${JSON.stringify(tasks, null, 2)}`);
    } catch (error) {
      setTestResult(`❌ Error: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="background-processing-test p-4 border rounded-lg bg-gray-50">
      <h3 className="text-lg font-semibold mb-4">Background Processing Test</h3>
      
      <div className="flex gap-2 mb-4">
        <button
          onClick={testWebsiteAnalysis}
          disabled={isLoading}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50"
        >
          Test Website Analysis
        </button>
        
        <button
          onClick={testEmailVerification}
          disabled={isLoading}
          className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 disabled:opacity-50"
        >
          Test Email Verification
        </button>
        
        <button
          onClick={testTaskRetrieval}
          disabled={isLoading}
          className="px-4 py-2 bg-purple-500 text-white rounded hover:bg-purple-600 disabled:opacity-50"
        >
          Test Task Retrieval
        </button>
      </div>
      
      {testResult && (
        <div className="bg-white p-3 rounded border">
          <h4 className="font-medium mb-2">Test Result:</h4>
          <pre className="text-sm whitespace-pre-wrap">{testResult}</pre>
        </div>
      )}
      
      {isLoading && (
        <div className="text-blue-600">
          Testing in progress...
        </div>
      )}
    </div>
  );
};

export default BackgroundProcessingTest;